export default __webpack_public_path__ + "static/media/bookguru.090f4dd0.png";